// extracted by mini-css-extract-plugin
export var closed = "_h3-1";
export var resizer = "_h3-0";